/**
 * Mode Detection - handles initial mode detection (local vs auth0)
 */

/**
 * Detect if auth card is gone (indicating local mode) and apply initial state
 */
export function detectInitialMode(state: any): void {
  const authCardGone = !document.getElementById('auth-card');
  if (authCardGone) {
    state.mode = 'local';
    const appEl = document.getElementById('app');
    if (appEl) {
      appEl.hidden = false;
    }
    const modeBanner = document.getElementById('mode-banner');
    const modeLabel = document.getElementById('mode-indicator-label');
    if (modeBanner) {
      modeBanner.hidden = false;
    }
    if (modeLabel) {
      modeLabel.textContent = 'Local mode';
    }
  }
}
